import request from '@/utils/request'

const normal_commodityApi = {
  normal_commodity_list: '/normal_commodity/',
  normal_commodity_create: '/normal_commodity/',
  normal_commodity_update: '/normal_commodity/',
  normal_commodity_delete: '/normal_commodity/',
  normal_commodity_transfer_list: '/normal_commodity/transfer/',
  normal_commodity_transfer_create: '/normal_commodity/transfer/',
  normal_commodity_transfer_delete: '/normal_commodity/transfer/',
  normal_commodity_template_list: '/normal_commodity/template/',
  normal_commodity_template_create: '/normal_commodity/template/'
}

/**
 * 列表
 */
export function normal_commodity_list (parameter) {
  return request({
    url: normal_commodityApi.normal_commodity_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 上传添加
 */
export function normal_commodity_template_create (parameter) {
  return request({
    url: normal_commodityApi.normal_commodity_template_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 添加
 */
export function normal_commodity_create (parameter) {
  return request({
    url: normal_commodityApi.normal_commodity_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function normal_commodity_update (parameter, normal_commodity_id) {
  return request({
    url: normal_commodityApi.normal_commodity_update + normal_commodity_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function normal_commodity_delete (normal_commodity_id) {
  return request({
    url: normal_commodityApi.normal_commodity_delete + normal_commodity_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
/**
 * 列表
 */
export function normal_commodity_transfer_list (parameter) {
  return request({
    url: normal_commodityApi.normal_commodity_transfer_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function normal_commodity_transfer_create (parameter) {
  return request({
    url: normal_commodityApi.normal_commodity_transfer_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
